import React from "react";

const Contact = () => {

        return(
   <section id="contact" className="py-20 bg-color1">
    <div className="container mx-auto px-6 text-center">
    <hr className="mb-20 h-1 bg-white rounded-full"/>
        <h1 className="text-4xl font-bold underline-offset-4 mb-0">Contact me</h1>
        <p className="text-md mb-4">if you need me , you can find me</p>
        <div>
        <a href="mailto:aldino6464@gmail.com" className="bg-gray-950 text-white font-semibold py-2 px-3 rounded-lg ">Find me </a>
   </div>
   
    </div>
    
   </section>
   
        )
}

export default Contact;